import React from 'react'
import PropTypes from 'prop-types'
import { Form, Icon } from 'antd'
import ExtensionCheckbox from './ExtensionCheckbox'
import css from './extension-selection.css'

const ExtensionSelection = ({
  availableExtensions,
  selectedExtensions,
  updateExtensions,
  locationId,
}) => {
  const onCheck = extensionId => {
    if (!locationId) return
    const index = selectedExtensions.indexOf(extensionId)
    if (index < 0) {
      selectedExtensions.push(extensionId)
    } else {
      selectedExtensions.splice(index, 1)
    }
    updateExtensions(locationId, selectedExtensions)
  }

  const extensionsAreAvailable =
    availableExtensions && availableExtensions.length
  const checked = extensionId =>
    selectedExtensions.some(ext => ext === extensionId)

  return (
    <div className={css.outerWrapper}>
      <div className={css.header}>
        <Icon type="phone" className={css.phone} />
        <h4>Extensions</h4>
      </div>
      {!extensionsAreAvailable ? (
        <p>No extensions found.</p>
      ) : (
        <div>
          <Form layout="horizontal">
            <Form.Item>
              {availableExtensions.map(extension => (
                <ExtensionCheckbox
                  key={extension.id}
                  extension={extension}
                  checked={checked(extension.id)}
                  onChange={onCheck}
                />
              ))}
            </Form.Item>
          </Form>
        </div>
      )}
    </div>
  )
}

ExtensionSelection.propTypes = {
  availableExtensions: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedExtensions: PropTypes.arrayOf(PropTypes.number).isRequired,
  updateExtensions: PropTypes.func.isRequired,
  locationId: PropTypes.string.isRequired,
}

export default ExtensionSelection



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/ExtensionSelection.js